// eslint-disable-next-line @typescript-eslint/no-var-requires
window.Buffer = window.Buffer || require('buffer').Buffer;

export function toBase64(text: string) {
  return Buffer.from(text).toString('base64');
}
export function fromBase64(text: string) {
  return Buffer.from(text, 'base64').toString('utf-8');
}
